import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withFirebase } from "../../Firebase";
import LikeComponent from '../../Card/LikeComponent';
import Tooltip from '@material-ui/core/Tooltip';
import editImage from '../../../assets/pencil.svg';
import Rater from 'react-rater';
import clip from "../../assets/clip.svg";
import Modal from "react-responsive-modal";
import RatingCapsuleModal from "../../Account/ProgressCapsules/RatingCapsuleModal";
import '../ChallengePage.css';

class InfoSectionComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ratingCapsule: 0,
            firstRate: 0,
            ratingModalOpen: false,
        };
    }

    componentDidMount() {
        this.setState({
            current_uid: this.props.firebase.auth.currentUser.uid
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.capsule.ratingList) {
            let ratingList = nextProps.capsule.ratingList || [];
            this.setState({ ratingList: ratingList })
            this.ratingFunction(ratingList);
            let isRate = ratingList.find(rating => this.state.current_uid === rating.user)
            if (isRate) {
                this.setState({ ratingOpen: false });
            }
        }
    }

    ratingFunction = (ratingList) => {
        let nbrRate = ratingList ? ratingList.length : 0;
        let total = 0;
        let finalRate = 0;
        ratingList.forEach((rating) => {
            total += rating.rate;
        })
        finalRate = nbrRate === 0 ? 0 : total / nbrRate;
        this.setState({ ratingCapsule: Math.round(finalRate) })
    }

    onRatingCaps = (rating) => {
        const { current_uid } = this.props
        const { ratingList } = this.state
        this.setState({ firstRate: rating });
        let isRate = ratingList.find(rating => current_uid === rating.user)
        if (isRate === undefined) {
            this.openRating()
        }
    }

    openRating = () => {
        this.setState({
            ratingModalOpen: true
        })
    }

    addRating = (rating, commentaire) => {
        const { capsule_id, current_user } = this.props
        const { current_uid, ratingList } = this.state
        let list = ratingList;
        const name = current_user.firstname + ' ' + current_user.lastname;
        const image = current_user.image_url_profile ? current_user.image_url_profile : '';
        const position = current_user.position ? current_user.position : '';
        list.push({ rate: rating, user: current_uid, commentaire: commentaire, username: name, position: position, image: image })
        this.ratingFunction(list)
        this.props.updateAfterRate(list)
        this.setState({ ratingOpen: false });
        this.props.firebase.db
            .collection("capsules")
            .doc(capsule_id)
            .set({ ratingList: list }, { merge: true })
            .catch((error) => console.error(error))
    }

    closeRating = () => {
        this.setState({
            ratingModalOpen: false,
        })
    }

    render() {
        const { capsule, capsule_id, polls, ideas, editable } = this.props;
        const { ratingCapsule, ratingOpen, current_uid } = this.state;
        let polls_length = polls.length;
        let ideas_length = ideas.length;
        let tags = capsule.tags ? capsule.tags : [];
        let status = capsule.status ? capsule.status : '';
        let nbVotes = capsule.ratingList ? capsule.ratingList.length : ''
        let attachments = capsule.attachments ? capsule.attachments : [];
        return (
            <>
                <div className="cointainer d-flex flex-colum justify-content-center">
                    <div className="w-75 position-relative d-flex flex-column align-items-center">
                        <div className="chal-info-container d-flex flex-column align-items-center w-100">
                            <div className="mt-4" hidden={editable}></div>
                            <div className="chal-numbers-container p-2">
                                <h1 className="stats-cps text-left">{polls_length} Sondages</h1>
                                <h1 className="stats-cps text-left">{ideas_length} Idées</h1>
                                <div className="chal-actions">
                                    <LikeComponent
                                        idcapsule={capsule_id}
                                        card={"challenge"}
                                    />
                                    <Tooltip title="Editer" aria-label="editer" hidden={capsule.creator !== current_uid}>
                                        <img src={editImage} alt="edit" className="edit-image pt-2 cursor-pointer" onClick={this.props.openEdit}></img>
                                    </Tooltip>
                                </div>
                            </div>
                            <div className="sizing-tags d-flex overflow-auto justify-content-center">
                                {tags.map((tag, index) => <div className="idea-tag" key={index}>
                                    <span className="idea-tag-text">#{tag}</span>
                                </div>)}
                            </div>
                            <div hidden={status !== 'finish'}>
                                <Rater onRate={({ rating }) => { this.onRatingCaps(rating) }} rating={ratingCapsule} total={5} interactive={ratingOpen} />
                                <h1 className="rate-text-card">{ratingCapsule}/5 ({nbVotes} votes)</h1>
                            </div>
                        </div>
                        <div className="pb-2 pt-2">
                            {attachments.map((attachment, index) =>
                                <a href={attachment.url} key={attachment.url}>
                                    <div className="d-flex">
                                        <img src={clip} className="mr-3 pb-1" alt="attach" />
                                        <h1 className="attachment-link cursor-pointer">
                                            {attachment.fileName}
                                        </h1>
                                    </div>
                                </a>
                            )}
                        </div>
                        <p className="cps-description d-flex justify-content-center">{capsule.description}</p>
                    </div>
                </div>
                <Modal
                    open={this.state.ratingModalOpen}
                    onClose={this.closeRating}
                    center
                    showCloseIcon={true}
                    styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
                >
                    <RatingCapsuleModal
                        onClose={this.closeRating}
                        addRating={this.addRating}
                        firstRate={this.state.firstRate}
                    />
                </Modal>
            </>)
    }
}

const styles_desktop = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
    },
    modal: {
        boxShadow: 'none',
        borderRadius: '4px',
        minHeight: "601px",
        maxWidth: "395px",
        top: "10%",
        padding: "0px",
    }
};

const styles_mobile = {
    overlay: {
        display: "block",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: 9999,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.79)",
        overflow: "auto",
        padding: "0px",
    },
    modal: {
        boxShadow: 'none',
        minHeight: "100%",
        width: "100%",
        padding: "0px",
    }
};

const InfoSection = withRouter(withFirebase(InfoSectionComponent));

export default InfoSection;